<ph-stack gap="tight">
    <ph-link-button
       variant="primary"
       trailing-icon="arrow-right"
       [routerLink]="urlPath"
       [queryParams]="urlQueryParams"
       (click)="onNavigate()">
        {{ label }}
    </ph-link-button>
    <ph-hint *ngIf="helperText">{{ helperText }}</ph-hint>
</ph-stack>
